export const SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID = 'SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID';
export const SET_SHOW_DUE_LIST = 'SET_SHOW_DUE_LIST';
export const SET_SHOW_DUE_LIST_FROM_MAIN_PAGE = 'SET_SHOW_DUE_LIST_FROM_MAIN_PAGE';
export const SET_VHND_EXECUTION_STATUS = 'SET_VHND_EXECUTION_STATUS';
export const SET_ARRIVAL_STATUS = 'SET_ARRIVAL_STATUS';
export const SET_REMOVAL_REASON_DATA = 'SET_REMOVAL_REASON_DATA';
export const SET_SESSION_DETAIL_DATA = 'SET_SESSION_DETAIL_DATA';
export const SET_MAIN_PAGE_TOOGLE = 'SET_MAIN_PAGE_TOOGLE';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_BENF_DUE_LIST_PAGE_TYPE = 'SET_BENF_DUE_LIST_PAGE_TYPE';
export const SET_AADD_BENF_LIST_PAGE = 'SET_AADD_BENF_LIST_PAGE';
export const SET_GO_TO_SERVICES = 'SET_GO_TO_SERVICES';
export const SET_ANM_ID_SELECTED = 'SET_ANM_ID_SELECTED';

export interface setShowUpcomingSessionDetailsPageById {
    type: typeof SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID;
    payload: any
};

export interface setShowDueList {
    type: typeof SET_SHOW_DUE_LIST;
    payload: any
};

export interface setShowDueListFromMainPage {
    type: typeof SET_SHOW_DUE_LIST_FROM_MAIN_PAGE;
    payload: any
};

export interface setVhndExecutionStatus {
    type: typeof SET_VHND_EXECUTION_STATUS;
    payload: any
};

export interface setArrivalStatus {
    type: typeof SET_ARRIVAL_STATUS;
    payload: any
};

export interface setRemovalReasonData {
    type: typeof SET_REMOVAL_REASON_DATA;
    payload: any
};

export interface setSessionDetailData {
    type: typeof SET_SESSION_DETAIL_DATA;
    payload: any
};

export interface setToogle {
    type: typeof SET_MAIN_PAGE_TOOGLE;
    payload: any
};

export interface setSessionId {
    type: typeof SET_SESSION_ID;
    payload: any
};

export interface setListPageType {
    type: typeof SET_BENF_DUE_LIST_PAGE_TYPE;
    payload: any
};

export interface setAddBenfListPage {
    type: typeof SET_AADD_BENF_LIST_PAGE;
    payload: any
};

export interface setGoToServices {
    type: typeof SET_GO_TO_SERVICES;
    payload: any
};

export interface setAnmIdSelectedByMoic {
    type: typeof SET_ANM_ID_SELECTED;
    payload: any
};

export type eventExecutionType = setShowUpcomingSessionDetailsPageById | setShowDueList | setVhndExecutionStatus | setArrivalStatus | setRemovalReasonData | setSessionDetailData
    | setToogle | setSessionId | setShowDueListFromMainPage | setListPageType | setAddBenfListPage | setGoToServices | setAnmIdSelectedByMoic;